export default __webpack_public_path__ + "static/media/unity-engine-logo.2e2af5b6.jpg";